import { gql } from "@apollo/client";
import { useCallback } from "react";
import { useQuery } from "@apollo/client/react";
import { CURRENCY_FRAGMENT } from "../../fragments/menu";

import type { MenuFetch } from "../../types/menuTypes";
import type { UseOptions } from "../hookTypes"

const FETCH_MENU = gql`
  query FetchMenu($id: ID!) {
    menu(id: $id) {
      id
      name
      description
      languages {
        position
        language
      }
      mainLanguage
      menuSections {
        id
        name
        position
        menuId
      }
      restaurantId
      ...CurrencyFragment
    }
  }
  ${CURRENCY_FRAGMENT}
`;

const useMenu = (id: string | number | undefined, options?: UseOptions) => {
  const { fetchPolicy = "cache-and-network", refetchOnMount = false } = options ?? {};

  const { data, loading, error, refetch } = useQuery<MenuFetch>(FETCH_MENU, {
    variables: { id: String(id) },
    fetchPolicy,
    notifyOnNetworkStatusChange: true,
  });

  if (refetchOnMount && !loading) {
    refetch();
  }

  const menu = data?.menu;

  const refetchMenu = useCallback(async () => {
    try {
      await refetch();
    } catch {
      // log if need
    }
  }, [refetch]);

  return {
    menu,
    loading,
    error: error as Error | null | undefined,
    refetchMenu,
  };
}

export default useMenu
